export const downloadCSV = (data: string, filePrefix: string) => {
  const blob = new Blob([data], { type: "text/csv;charset=utf-8;" });

  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.setAttribute("hidden", "");
  a.setAttribute("href", url);
  a.setAttribute("download", `${filePrefix}-info.csv`);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const objectToCsv = (data: any) => {
  const csvRows = [];

  //get the headers
  const headers = Object.keys(data);
  csvRows.push(headers.join(";"));

  //loop over the rows
  const values = headers.map((header) => {
    const escapedValue = ("" + data[header]).replace(/"/g, '\\"');
    return `"${escapedValue}"`;
  });
  csvRows.push(values.join(";"));

  //form escaped comma separated values
  return csvRows.join("\n");
};
